const ERROR_MESSAGE_TITLE = 'authentication.message.error';
const NOT_SEND_ERROR = 'authentication.send.not.send.error';

export class AccountCreationHelpService {

    /* @ngInject */
    constructor(userSessionService, toastr, $stateParams, $state, $translate, $log) {
        this.userSessionService = userSessionService;
        this.toastr = toastr;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$log = $log;

        $translate([
            ERROR_MESSAGE_TITLE,
            NOT_SEND_ERROR
        ]).then(translations => this.translations = translations)
            .catch(error => this.$log.error(error));
    }

    handleActivationNavigation(twoFactorEnabled, username, user, email) {
        if (twoFactorEnabled) {
            this.$state.go('activate.phone', {
                state: this.$stateParams.state,
                username: username,
                email: email
            });
        } else {
            this.$state.go('setpassword', {
                id: user.id,
                username: username,
                email: email
            });
        }
    }

    handleActivationHttpError(response, username) {
        if (response.status === 308) {
            this.$state.go('login.username', {
                username: username
            });
        }
        if (response.status === 403) {
            this._displayError(response.data.message);
        }
        if (response.status === 400 || response.status === 500 ) {
            this._displayError(this.translations[NOT_SEND_ERROR]);
        }
    }

    _displayError(message) {
        this.toastr.error(message, this.translations[ERROR_MESSAGE_TITLE]);
    }
}